import axios from '@/utils/request'

export default {
	// 2021-09-16
	findByPhone(params) {
		return axios.get('/users/find-by-phone', params);
	},
	// 2021-10-13
	registWedding(params) {
		return axios.post('/users/regist-wedding', params);
	},
	// 2021-11-09
	loginWedding(params) {
		return axios.post('/users/login-wedding', params);
	},
	// 2021-09-16
	findByUnionid(params) {
		return axios.get('/users/find-by-unionid', params);
	},
	// 2021-09-16
	updateName(id, params) {
		return axios.put('/users/' + id + '/update-name', params)
	},
	// 2021-09-16
	updatePassword(id, params) {
		return axios.put('/users/' + id + '/update-password', params)
	},
	// 2021-09-16
	findById(id) {
		return axios.get('/users/' + id)
	},
	// 2021-09-16
	search(params) {
		return axios.get('/users', params)
	},
	// 2021-09-16
	update(id, params) {
		return axios.put('/users/' + id, params)
	},
	//     // 2021-01-16
	//     updateActions(id, params) {
	//         return axios.put('/users/' + id + '/update-actions', params)
	//     },
	//     // 2021-01-16
	//     updateManageUsers(id, params) {
	//         return axios.put('/users/' + id + '/update-manage-users', params)
	//     },
	// 2021-09-16
	create(params) {
		return axios.post('/users', params);
	},
	// 2021-09-16 //删除
	invalid(id) {
		return axios.delete('/users/' + id + '/invalid')
	},
	// 2021-09-16 
	recovery(id) {
		return axios.put('/users/' + id + '/recovery')
	},
	//     // 2020-07-28
	//     findByShopId(params) {
	//         return axios.get('/users/find-by-shop-id', params)
	//     },
	//     //   updateCommonOperation(id, params) {
	//     //     return axios.put('/users/' + id + '/update-common-operation', params)
	//     //   },

	// 2021-10-13
	updateInfo(id, params) {
		return axios.put('/users/' + id + '/update-info', params)
	},

	// 2021-09-23
	findByTenantId() {
		return axios.get('/users/find-by-tenant-id')
	},


}

